import React from 'react';
import { Document, Page, StyleSheet, Font } from '@react-pdf/renderer'
import Header from './Header'
import Footer from './Footer'
import Body from "./Body";
import { ServerProvider } from "./Hooks/ServerContext";
import { PdfContextProvider } from "./Hooks/PdfTypeContext";
import RobotoBold from '../../Fonts/Roboto-Bold.ttf'
import RobotoLight from '../../Fonts/Roboto-Light.ttf'
import RobotoMedium from '../../Fonts/Roboto-Medium.ttf'
import RobotoRegular from '../../Fonts/Roboto-Regular.ttf'

const styles = StyleSheet.create({
    page: {
        flexDirection: 'row',
        backgroundColor: 'green'
    },
    section: {
        margin: 10,
        padding: 10,
        flexGrow: 1
    },
    pageContent: {
        display: 'flex',
        flexDirection: 'column',

    },
    body: {

        backgroundColor: '#red',
        margin: 55,
    },

});

// const charter = prepareForEdit(charters[0]);
const PdfDocument = ({ auth, pdfType, server, charter, showWeight, includeImages=true }) => {
    Font.registerEmojiSource({
        format: 'png',
        url: 'https://twemoji.maxcdn.com/2/72x72/',
    });

    Font.register({
        family: 'RobotoBold',
        src: RobotoBold,
    })
    Font.register({
        family: 'RobotoLight',
        src: RobotoLight,
    })
    Font.register({
        family: 'RobotoMedium',
        src: RobotoMedium,
    })
    Font.register({
        family: 'RobotoRegular',
        src: RobotoRegular,
    })


    const newPdfType = pdfType !== 'Itinerary' ? pdfType : charter.qGov ? 'ItineraryQGov' : 'Itinerary'
    const bidHistory = pdfType === 'bidHistory';
    return <PdfContextProvider pdfType={newPdfType}>
        <ServerProvider server={server}>
            <CustomDocument bidHistory={bidHistory} charter={charter} auth={auth} showWeight={showWeight} includeImages={includeImages} />
        </ServerProvider>
    </PdfContextProvider>;
};

export const CustomDocument = ({ bidHistory, charter, auth, showWeight,newPdfType, includeImages }) => {
    return<>
    <Document fileName={bidHistory ? 'Bid History - JB' + charter.request.jobReference : 'Itinerary - JB' + charter.request.jobReference} >
        <Page wrap size="A4" style={styles.pageContent} >
            <Header auth={auth} bidHistory={bidHistory} charter={charter} newPdfType={newPdfType} />
            <Body auth={auth} bidHistory={bidHistory} charter={charter} showWeight={showWeight} style={styles.body} newPdfType={newPdfType} includeImages={includeImages} />
            <Footer charter={charter} newPdfType={newPdfType} />
        </Page>
    </Document>
    </>
};
export default PdfDocument;
